import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { LoaderService } from '@core/services/loader.service';
import { HttpService } from '@core/services/http.service';
import { CommonService } from '@app/shared/services/common.service';
import { LICENSE_TYPE_OPTIONS, SEARCH_INFO_FIELDS } from './search.constants';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { SEARCH_GRID_COLUMNS } from './search.constants';
import { DynamicSearchFormComponent } from '@app/dynamic-search-form/dynamic-search-form.component';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { AlertService } from '@app/@core/services/alert.service';
import { LocalService } from '@core/services/local.service';
import { forkJoin } from 'rxjs';
import { AlertModule } from '@app/shared/modules/alert/alert.module';
import { Router } from '@angular/router';
import moment from 'moment';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [DynamicSearchFormComponent, CommonModule, DataGridComponent, AlertModule, MaterialUIModule],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  licenseTypeOptions: any[] = [];
  isLicenseTypeLoading = true;
  searchInfo: any[] = SEARCH_INFO_FIELDS;

  disableSearchButton = false;
  latestFormValue: any = {};

  searchResults: any[] = [];
  searchGridConfig: DataGridVO = DataGridVO.create({ data: [] });
  showColumnChooser = false;
  allColumns = SEARCH_GRID_COLUMNS;
  visibleColumns: { [key: string]: boolean } = {
    educator_name: true,
    dob: true,
    ssn: true,
    license_number: true,
    email: true,
    license_effective_date: true,
    license_expiration_date: true
  };
  @ViewChild(DataGridComponent) dataGridComponent!: DataGridComponent;
  @ViewChild(DynamicSearchFormComponent) searchFormComponent!: DynamicSearchFormComponent;
  licenseKindOptions: any;
  endorsementTypeOptions: any;
  districtEmployedOptions: any;
  toastMessage: any;
  toastMessages: any;
  toastTitle: string;
  toastTimer: any;
  showToast: boolean;

  constructor(
    private httpService: HttpService,
    private loaderService: LoaderService,
    private cd: ChangeDetectorRef,
    private commonService: CommonService,
    private alertService: AlertService,
    private sessionStorage: LocalService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadDropdownDataMessages();
    const apiHost = sessionStorage.getItem('apiHost');
    this.httpService.get(`/platform/master/lookup/category/LICENSE-ENDORSEMENT`).subscribe((resp: any) => {
      console.log('LICENSE-ENDORSEMENT first item keys:', resp?.data?.[0] ? Object.keys(resp.data[0]) : 'no data');
      console.log('LICENSE-ENDORSEMENT first item:', JSON.stringify(resp?.data?.[0]));
    });
    this.httpService.get('/domain/lookup?requestType=LICENSE KIND').subscribe((resp: any) => {
      if (resp && resp.data && Array.isArray(resp.data)) {
        this.licenseKindOptions = resp.data.map((item: any) => ({
          label: item.value,
          value: item.key
        }));
      } else {
        this.licenseKindOptions = [];
      }
      // Update searchInfo with fetched license kind options
      this.searchInfo = this.searchInfo.map(field => {
        if (field.fieldName === 'license_kind') {
          return { ...field, options: this.licenseKindOptions };
        }
        return field;
      });
      this.cd.detectChanges();
    });
    this.httpService.get(API_ENDPOINTS.LOOKUP_LICENSE_TYPES).subscribe((resp: any) => {
      if (resp && resp.data && Array.isArray(resp.data)) {
        this.licenseTypeOptions = resp.data.map((item: any) => ({
          label: item.value,
          value: item.key
        }));
      } else {
        this.licenseTypeOptions = [];
      }
      this.searchInfo = this.searchInfo.map(field => {
        if (field.fieldName === 'license_type') {
          return { ...field, options: this.licenseTypeOptions };
        }
        return field;
      });
      this.cd.detectChanges();
    })
    this.httpService.get(API_ENDPOINTS.LOOKUP_ENDORSEMENT).subscribe((resp: any) => {
      console.log('ENDORSEMENT first item keys:', resp?.data?.[0] ? Object.keys(resp.data[0]) : 'no data');
      console.log('ENDORSEMENT first item:', JSON.stringify(resp?.data?.[0]));
      if (resp && resp.data && Array.isArray(resp.data)) {
        this.endorsementTypeOptions = resp.data
          .filter((item: any) => (item.key ?? item.id ?? item.code ?? item.lookupid) != null)
          .map((item: any) => ({
          label: item.value || item.name || item.text || item.description,
          value: item.key ?? item.id ?? item.code ?? item.lookupid
        }));
      } else {
        this.endorsementTypeOptions = [];
      }
      this.searchInfo = this.searchInfo.map(field => {
        if (field.fieldName === 'endorsement_type') {
          return { ...field, options: this.endorsementTypeOptions };
        }
        return field;
      });
      this.cd.detectChanges();
    });
    this.httpService.get('/domain/lookup?requestType=DISTRICT').subscribe((resp: any) => {
      if (resp && resp.data && Array.isArray(resp.data)) {
        this.districtEmployedOptions = resp.data.map((item: any) => ({
          label: item.value,
          value: item.key
        }));
      } else {
        this.districtEmployedOptions = [];
      }
      // Update searchInfo with fetched district options
      this.searchInfo = this.searchInfo.map(field => {
        if (field.fieldName === 'district_employed') {
          return { ...field, options: this.districtEmployedOptions };
        }
        return field;
      });
      this.cd.detectChanges();
    });

    this.httpService.get(API_ENDPOINTS.PLACEHOLDER_MESSAGES).subscribe((resp: any) => {
      if (resp && resp.data && Array.isArray(resp.data)) {
        const placeholderMap = resp.data.reduce((acc: any, item: any) => {
          if (item.key && item.value) acc[item.key] = item.value;
          return acc;
        }, {});
        this.searchInfo = this.searchInfo.map(field => {
          const dynamicPlaceholder = placeholderMap[field.fieldName];
          return {
            ...field,
            placeholder: dynamicPlaceholder !== undefined ? dynamicPlaceholder : field.placeholder
          };
        });
      }
    });

  }

  private async loadDropdownDataMessages() {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES')]).subscribe({
        next: (item: any) => {
          this.toastMessages = item[0].data;
          this.toastMessage = {};
          this.toastMessages.forEach((message: any) => {
            if (message.key && message.value !== undefined) {
              this.toastMessage[message.key] = message.value;
            }
          });
          window.localStorage.setItem('toastMessages', JSON.stringify(this.toastMessages));
          this.cd.detectChanges();

        },
        error: error => {
          console.error('Error loading dropdown data:', error);
        }
      });
  }

  closeColumnChooser() {
    this.showColumnChooser = false;
    this.updateGridConfig();
  }
  onFieldChange(fieldName: string, value: any) {
  }
  refreshSearchResults() {
    if (this.searchFormComponent && typeof this.searchFormComponent.reset === 'function') {
      this.searchFormComponent.reset();
    }
    this.searchInfo = this.searchInfo.map(field => {
      if (field.fieldName === 'endorsement_type') {
        return { ...field, value: field.datatype === 'multiselectdropdown' ? [] : '' };
      }
      if (field.datatype === 'dropdown') {
        return { ...field, value: '' };
      }
      if (field.datatype === 'multiselectdropdown') {
        return { ...field, value: [] };
      }
      return { ...field, value: '' };
    });
    this.searchResults = [];
    this.updateGridConfig();
    this.cd.detectChanges();
  }
  downloadExcel() {
    const visibleCols = this.allColumns.filter(col => this.visibleColumns[col.key]);
    if (visibleCols.length === 0) {
      window.alert('No columns selected for export');
      return;
    }
    if (
      this.dataGridComponent &&
      this.dataGridComponent.dataGrid &&
      this.dataGridComponent.dataGrid.instance &&
      typeof this.dataGridComponent.exportFilteredDataToExcel === 'function'
    ) {
      const columns = visibleCols.map(col => ({
        label: col.caption,
        key: col.key,
        dataType: col.dataType
      }));
      const sheetName = 'SearchResults.xlsx';
      const gridInstance = this.dataGridComponent.dataGrid.instance;
      const oldPageSize = gridInstance.pageSize ? gridInstance.pageSize() : null;
      const totalCount = gridInstance.totalCount ? gridInstance.totalCount() : null;
      if (oldPageSize && totalCount && oldPageSize < totalCount) {
        gridInstance.pageSize(totalCount);
        setTimeout(() => {
          this.dataGridComponent.exportFilteredDataToExcel(columns, sheetName);
          setTimeout(() => {
            gridInstance.pageSize(oldPageSize);
          }, 500);
        }, 200);
        return;
      }
      this.dataGridComponent.exportFilteredDataToExcel(columns, sheetName);
      return;
    }
    const rows = Array.isArray(this.searchResults) ? this.searchResults : [];
    if (rows.length === 0) {
      window.alert('No data to export');
      return;
    }
    const exportRows = rows.map(row => {
      const filtered: any = {};
      visibleCols.forEach(col => {
        filtered[col.key] = row[col.key];
      });
      return filtered;
    });
    const exportColumns = visibleCols.map(col => ({
      label: col.caption,
      key: col.key,
      dataType: col.dataType
    }));
    const sheetName = 'SearchResults.xlsx';
    this.commonService.exportToExcel(exportRows, exportColumns, sheetName);
  }


  exportSearchResults() {
    const columns = this.allColumns.filter(col => this.visibleColumns[col.dataField]);
    if (columns.length === 0) {
      alert('No columns selected for export');
      return;
    }
    const rows = Array.isArray(this.searchResults) ? this.searchResults : [];
    if (rows.length === 0) {
      alert('No data to export');
      return;
    }
    // Map columns to the format expected by exportToExcel (label/key)
    const exportColumns = columns.map(col => ({
      label: col.caption,
      key: col.dataField,
      dataType: col.dataType
    }));
    const sheetName = 'SearchResults.pdf';
    this.commonService.exportToExcel(rows, exportColumns, sheetName);
  }

  toggleColumnChooser() {
    this.showColumnChooser = !this.showColumnChooser;
    this.updateGridConfig();
  }
  onColumnClick(col: any) {
    const key = col.key || col.dataField;
    this.visibleColumns = { ...this.visibleColumns, [key]: !this.visibleColumns[key] };
    this.updateGridConfig();
    this.cd.detectChanges();
  }
  updateGridConfig() {
    this.searchGridConfig = DataGridVO.create({
      data: this.searchResults,
      customHeaders: this.allColumns.filter(col => this.visibleColumns[col.key]),
      visibleColumns: this.visibleColumns,
      showActionsColumn: false,
      role: 'lookup-search',
      activeTab: 'lookup-search',
      disableApplicationClick: false
    });
  }

  onEducatorNameClick = (_name: string, event?: Event, rowData?: any): void => {
    if (event && typeof (event as any).preventDefault === 'function') {
      (event as Event).preventDefault();
    }
    const personId = rowData?.person_id;
    if (personId == null || personId === '') {
      this.alertService.error('User record has no person id; cannot open detail.', true);
      return;
    }
    this.router.navigate(['/pages/lookup-user', String(personId)]);
  };
  private formatDateISO(date: any): string {
    if (!date) return '';
    const parsed = moment(date, ['MM/DD/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
    if (parsed.isValid()) {
      return parsed.format('YYYY-MM-DD');
    }

    const fallback = moment(date);
    return fallback.isValid() ? fallback.format('YYYY-MM-DD') : '';
  }
  onSearch(formValue: any) {
    this.loaderService.show();
    let payload = {}
    Object.keys(formValue).forEach(field => {
      const value = formValue[field];
      if (['license_type', 'endorsement_type', 'license_kind', 'district_employed'].includes(field)) {
        if (Array.isArray(value) && value.length > 0) {
          payload[field] = value;
        } else if (!Array.isArray(value) && value !== null && value !== undefined && value !== '') {
          payload[field] = value;
        }
      } else if (Array.isArray(value) && value.length === 2) {
        const [from, to] = value;
        if (from || to) {
          payload[field] = {
            from: from ? this.formatDateISO(from) : '',
            to: to ? this.formatDateISO(to) : ''
          };
        }
      } else if (value !== undefined && value !== null && value !== '') {
        payload[field] = value;
      }
    });
    this.httpService.post('/search/educator-search', payload).subscribe({
      next: (resp: any) => {
        if (resp && resp.data.status === 'failed') {
          this.searchResults = [];
          this.updateGridConfig();
          this.loaderService.hide();
          let msg = this.toastMessage['T0055'];
          this.showFailureToastMsg(msg); this.cd.detectChanges();
          return;
        } else {
          let data = Array.isArray(resp) ? resp : (resp?.data || []);
          this.searchResults = data.data.map((item: any) => {
            let ssnOrItin = '---';
            if (item.ssn_number) {
              ssnOrItin = this.commonService.decrypt(item.ssn_number) || '---';
            } else if (item.itin_number) {
              ssnOrItin = this.commonService.decrypt(item.itin_number) || '---';
            }
            let effectiveDateRaw = item.effective_from ? this.commonService.decrypt(item.effective_from) : '';
            let expiryDateRaw = item.expiry_date ? this.commonService.decrypt(item.expiry_date) : '';
            // If decryption returns empty, use raw API value
            if (!effectiveDateRaw && item.effective_from) effectiveDateRaw = item.effective_from;
            if (!expiryDateRaw && item.expiry_date) expiryDateRaw = item.expiry_date;
            console.log('Effective Raw:', effectiveDateRaw, 'Expiry Raw:', expiryDateRaw);
            let effectiveDate = null;
            let expiryDate = null;
            if (effectiveDateRaw) {
              const parsed = moment(effectiveDateRaw, ['MM/DD/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
              const fallback = parsed.isValid() ? parsed : moment(effectiveDateRaw);
              if (fallback.isValid()) effectiveDate = fallback.startOf('day').toDate();
            }
            if (expiryDateRaw) {
              const parsed = moment(expiryDateRaw, ['MM/DD/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
              const fallback = parsed.isValid() ? parsed : moment(expiryDateRaw);
              if (fallback.isValid()) expiryDate = fallback.startOf('day').toDate();
            }
            console.log('Effective Date Object:', effectiveDate, 'Expiry Date Object:', expiryDate);
            return {
              person_id:
                item.person_id != null
                  ? item.person_id
                  : item.educator_person_id != null
                    ? item.educator_person_id
                    : null,
              educator_name: item.educator_name || '---',
              dob: this.commonService.decrypt(item.date_of_birth) || '---',
              ssn: ssnOrItin,
              license_number: item.license_number ? this.commonService.decrypt(item.license_number) || '---' : '---',
              email: this.commonService.decrypt(item.primary_email) || '---',
              license_effective_date: effectiveDate,
              license_expiration_date: expiryDate,
              prior_name: item.prior_name ? this.commonService.decrypt(item.prior_name) || '---' : '---',
              phone: item.primary_phone ? this.commonService.decrypt(item.primary_phone) || '---' : '---',
              itin_number: item.itin_number ? this.commonService.decrypt(item.itin_number) || '---' : '---',
              cd_license_type: item.cd_license_type ? this.commonService.decrypt(item.cd_license_type) || '---' : '---',
              cd_license_kind: item.cd_license_kind || '---',
              cd_endorsement: item.cd_endorsement || '---',
            };
          });
          this.updateGridConfig();
          this.loaderService.hide();
          this.cd.detectChanges();
        }
      },
      error: () => {
        this.searchResults = [];
        this.updateGridConfig();
        this.loaderService.hide();
      }

    });
  }

  resetEvent() {
    this.searchInfo = this.searchInfo.map(field => {
      if (field.fieldName === 'endorsement_type') {
        return { ...field, value: field.datatype === 'multiselectdropdown' ? [] : '' };
      }
      if (field.datatype === 'dropdown') {
        return { ...field, value: '' };
      }
      if (field.datatype === 'multiselectdropdown') {
        return { ...field, value: [] };
      }
      return field;
    });
    this.cd.detectChanges();
    console.log('Reset');
  }
  get endorsementTypeKey(): any {
    return this.searchInfo.find(f => f.fieldName === 'endorsement_type')?.key;
  }

  onFormValueChange(formValue: any) {
    this.latestFormValue = formValue;
    // Strict: Only enable search if SSN/ITIN is empty or has at least minlength digits
    const ssnField = this.searchInfo.find(f => f.fieldName === 'ssn');
    const ssnValue = formValue?.ssn || '';
    const digits = ssnValue.replace(/\D/g, '');
    // If SSN/ITIN is present and less than minlength, always disable
    this.disableSearchButton = digits.length > 0 && digits.length < (ssnField?.minLength || 4);
  }
  setShortToastTimer() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
    this.toastTimer = setTimeout(() => {
      this.showToast = false;
    }, 4000);

  }
  closeToast() {
    this.showToast = false;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }

  showFailureToastMsg(msg: string) {
    this.toastTitle = '';
    // this.toastMessageText = msg;
    this.alertService.error(msg, true);
    // this.toastType = 'error';
    // this.showToast = true;
    // this.setShortToastTimer();
    window.scrollTo(0, 0);
  }

  showSuccessToastMsg(msg: string) {
    this.toastTitle = '';
    // this.toastMessageText = msg;
    this.alertService.success(msg, true);
    // this.toastType = 'success';
    // this.showToast = true;
    // this.setShortToastTimer();
    window.scrollTo(0, 0);
  }
  isSearchDisabled(formValue: any): boolean {
    return this.disableSearchButton;
  }

  hasFormValues(): boolean {
  const form = this.searchFormComponent?.form;
  if (!form) return false;
  const value = form.value;
  return Object.keys(value).some(key => {
    const val = value[key];
    if (Array.isArray(val)) {
      return val.length > 0 && val.some(v => v !== null && v !== undefined && v !== '');
    }
    if (val && typeof val === 'object') {
      return Object.values(val).some(v => v !== null && v !== undefined && v !== '');
    }
    return val !== null && val !== undefined && val !== '';
  });
}
}